<!-- BEGIN #app -->
<div id="app" class="app app-full-height app-without-header">
  <!-- Camera Watch View - Full Screen -->
  <router-outlet></router-outlet>
</div>
<!-- END #app -->
